import {guard, ARRAY, INTEGER, MINMAX, NULLABLE, OBJECT, STRING} from '@acng/frontend-rubicon';
import {debug} from '@acng/frontend-bounty/dom/debug.js';

import {cdn} from '../../core/service/cdn.js';
import {get, put} from '../../core/service/backend.js';
import {media} from '../../core/service/env.js';
import {getFallbackImageUrl} from '../../layout/service/fallback-image.js';
import {FRIENDSHIP} from '../model/friendship.js';

export {put_ as put, getListOfAmateur};

/**
 * @param {Element} element
 * @param {Amateur} amateur
 * @param {string} status
 */
const put_ = async (element, amateur, status) => await put(`friends/${amateur.id}`, {status}, element);

const ex1 = 'friend list of amateur from cdn';

/**
 * @param {Element} element
 * @param {Amateur} amateur
 *
 * @returns {Promise<Friend[]>}
 */
const getListOfAmateur = async (element, amateur) => {
  const friends = await cdn(`/api/friends/${amateur.id}`);

  DEBUG: if (debug(element)) console.info(ex1, {element, amateur, friends});
  ASSERT: guard(friends, FRIEND_LIST_OF_AMATEUR_DATA, ex1);

  return friends.map((data) => new Friend(data));
};

/**
 * @param {Element} element
 */
export const getList = async (element) => {
  const friendships = await get('friends', element);

  ASSERT: guard(friendships, USER_FRIENDSHIP_LIST, 'user friend list from api');

  return friendships;
};

const USER_FRIENDSHIP_LIST = /* @__PURE__ */ ARRAY(FRIENDSHIP);

const FRIEND_OF_AMATEUR = /* @__PURE__ */ (() =>
  OBJECT({
    nickname: STRING,
    age: NULLABLE(MINMAX(18, 150, INTEGER)),
    image_uri: NULLABLE(STRING),
  }))();

const FRIEND_LIST_OF_AMATEUR_DATA = /* @__PURE__ */ ARRAY(FRIEND_OF_AMATEUR);

class Friend {
  /**
   * @param {Valid<FRIEND_OF_AMATEUR>} data
   */
  constructor(data) {
    this.name = data.nickname;
    this.age = data.age;
    this.image = data.image_uri ? `${media.user}/${data.image_uri}` : getFallbackImageUrl();
  }
}
